import { useEffect, useState } from "react";
import { ISelectedNode, Modules } from "../../../types";
import { useLazyFetch } from "../../../system/useFetch";
import { IDashboard } from "../types";
import { Paper, useTheme } from "@mui/material";
import { Dashboard } from "@mui/icons-material";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import { getPalette } from "../../../configuration/configuration";
import { getEmptyDashboard } from "./utils";

interface IProps {
  selectedNode: ISelectedNode;
  setDashboard: (dashboard: IDashboard) => void;
}

const BrowserItems = ({ selectedNode, setDashboard }: IProps) => {
  const theme = useTheme();
  const [ selectedDashboard, setSelectedDashboard ] = useState<IDashboard | null>(null);
  const [ getDashboards, { data: dashboards }] = useLazyFetch<IDashboard[]>(true);

  useEffect(() => {
    getDashboards({
      module: "dashboard",
      query: "getDashboards",
      payload: {
        nodeID: selectedNode.nodeID,
        nodeType: selectedNode.type,
        moduleID: Modules.INTERRUPTIONS
      }
    });
  }, []);

  return (
    <div className="p-2 display-grid align-items-start justify-items-center"
      style={{ gridRow: "1 / span 1", overflowY: "auto" }} >
      <div className="display-flex-row gap-2 flex-wrap">
        { dashboards && dashboards.map((dashboard, index) => {

          return (
            <Paper key={`dashboard-${index}`} elevation={0}
              className={`p-0 display-flex-column align-items-stretch ${ selectedDashboard === dashboard ? "Mui-selected" : "" } `}
              sx={{
                overflow:"hidden",
                "&:hover": {
                  backgroundColor: theme.palette.action.hover.replace("0.08", "0.1")
                },
              }}
              onClick={() => setSelectedDashboard(dashboard)}
              onDoubleClick={() => setDashboard(dashboard)}>
              <div className="display-flex-row gap-1 align-items-stretch" style={{ width: 300, height: 74, }}>
                <div className="display-flex-row justify-content-center align-items-center"
                  style={{ width: 40,  background: `rgba(${getPalette().rgbColor[dashboard.customConfig.colorIndex ?? 0]})` }}>
                  <Dashboard/>
                </div>
                <div className="display-flex-column justify-content-center flex-grow-1" >
                  <strong>{dashboard.name}</strong>
                  {dashboard.owner && <strong>{`[ ${dashboard.owner} ]`}</strong>}
                </div>
              </div>
            </Paper>
          );
        })
        }
        <Paper elevation={1}
          className="p-0 display-flex-column Mui-ba"
          sx={{
            bgcolor: "info.main",
            width: 300,
            height: 74,
            "&:hover": {
              backgroundColor: theme.palette.action.hover.replace("0.08", "0.1")
            },
          }}
          onDoubleClick={() => setDashboard(getEmptyDashboard())}>

          <div className="display-flex-row gap-1 align-items-stretch" style={{ width: 300, height: 74, }}>
            <div className="display-flex-row justify-content-center align-items-center" style={{ width: 40,  background: "rgba(0, 0, 100, .3)" }}>
              <DashboardCustomizeIcon/>
            </div>
            <div className="display-flex-column justify-content-center flex-grow-1" >
              <strong>New Dashboard</strong>
            </div>
          </div>
        </Paper>
      </div>
    </div>
  );
};

export default BrowserItems;